import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { useSingleTarget } from "../../hooks/useManagement";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import { separate } from "../../utils/separate";
import Button from "../Button/Button";
import { DeleteUserTargetModal } from "../Dialog/DeleteUserTargetModal";
import { EditTargetUserModal } from "../Dialog/EditTargetUserModal";
import Loading from "../Loadings/LoadingTable";
import { Table } from "../Table/Table";
import TargetChart from "../TargetChart/TargetChart";

const TargetUserTable = () => {
  const [Search, setSearch] = useState("");
  const { id } = useParams();
  const [targetId, setTargetId] = useState("");
  const [targetObj, setTargetObj] = useState("");
  const [show, setShow] = useState({ edit: false, delete: false });
  const navigate = useNavigate();
  const { data, isLoading } = useSingleTarget({ sale_target_id: id });
  const target = data?.data?.usersSaleTarget;
  const TargetListHeaderTitle = [
    "ردیف",
    "نام و نام خانوادگی",
    "تارگت",
    "فروش",
    "باقیمانده فروش",
    "تاریخ ایجاد تارگت",
    "عملیات",
  ];
  const items = target
    ?.filter((target) => {
      if (Search === "") {
        return target;
      } else if (target.FromDate.includes(Search)) {
        return target;
      }
    })
    .map((target, index) => {
      return (
        <tr key={index} style={{ cursor: "pointer" }}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {index + 1}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {(target?.user?.FirstName ? target?.user?.FirstName : "") +
                " " +
                (target?.user?.LastName ? target?.user?.LastName : "")}
            </span>
          </td>

          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {separate(target?.AmountUserSaleTarget)}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {separate(target?.sale)}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {separate(target?.AmountUserSaleTarget - target?.sale)}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {MiladiToShamsi(target?.created_at)}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              <div className="d-flex">
                <Button
                  small="fit-content"
                  bgColor="#009ef7"
                  className="mx-1"
                  onclick={() => {
                    setShow({ ...show, edit: true });
                    setTargetObj(target);
                  }}
                >
                  <FaEdit size="16px" color="#fff" />
                </Button>
                <Button
                  small="fit-content"
                  bgColor="#f1416c"
                  className="mx-1"
                  onclick={() => {
                    setShow({ ...show, delete: true });
                    setTargetId(target?.IdUSerSaleTarget);
                  }}
                >
                  <FaTrash size="16px" color="#fff" />
                </Button>
              </div>
            </span>
          </td>
        </tr>
      );
    });
  if (isLoading) return <Loading />;
  return (
    <>
      <Tabs defaultActiveKey="لیست اعضا" className="mb-3">
        <Tab eventKey="لیست اعضا" title="لیست اعضا">
          <Table
            className="mt-3"
            setSearch={setSearch}
            headerTitle={TargetListHeaderTitle}
            items={items ? items : <Loading />}
            title={`لیست اعضا تارگت (${items.length})`}
          />
        </Tab>
        <Tab eventKey="نمودار" title="نمودار">
          <TargetChart target={data} />
        </Tab>
      </Tabs>
      <DeleteUserTargetModal
        show={show.delete}
        handleClose={() => setShow({ ...show, delete: false })}
        targetId={targetId}
      />
      <EditTargetUserModal
        show={show.edit}
        handleClose={() => setShow({ ...show, edit: false })}
        target={targetObj}
      />
    </>
  );
};

export default TargetUserTable;
